import {WorkspaceModelType} from "@stores/WorkspaceStore";
import {updateItemChildIdsRemove} from "./updateItem";
import {updateWorkspaceChildIdsAdd} from "../workspace/updateWorkspace";
import {CrudServices} from "../../platform/services/types/ServiceDependencies";
import {DataSourceManager} from "@stores/dataSources/DataSourceManager";


export const removeFromCluster = (
    services: CrudServices,
    dsManager: DataSourceManager,
    itemId: string,
    targetClusterId: string,
    workspace: WorkspaceModelType
) => {
    let waitUpdateWorkspace = Promise.resolve();
    const wsUpdateServices = {...services, dsManager};

    const itemMST = workspace.items.get(itemId)!;

    const waitUpdateItems = updateItemChildIdsRemove(services, dsManager, targetClusterId, itemId, workspace);

    if (itemMST.parentIds.length <= 1 && !workspace.childIds.includes(itemId)) {
        waitUpdateWorkspace = updateWorkspaceChildIdsAdd(wsUpdateServices, workspace, itemMST.id);
    }

    return Promise.all([waitUpdateItems, waitUpdateWorkspace]);
}
